import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useAdDetails } from '@/views/Ads/useAdDetails';
import * as S from '@/components/Ad/WarningPendingState/WarningPendingState.styles';

export const WarningPendingState = () => {
  const { t } = useTranslation();
  const { adDetails } = useAdDetails();

  if (!adDetails) return null;

  return (
    <S.Warning>
      <S.WarningTitle $variant="4">
        {t('pages.ad.top_warning_title')}
      </S.WarningTitle>
      <S.WarningDescription $variant="1">
        <Trans
          i18nKey="pages.ad.top_warning_description"
          components={{
            link1: (
              <a
                target="_blank"
                href="https://cert.az/news/2020/kiberdeleduzlar-azerpoct-mmc-nin-adina-saxta-saytlar-yaradaraq-insanlari-teleye-salmaga-calisir"
              />
            ),
          }}
        />
      </S.WarningDescription>
    </S.Warning>
  );
};
